export const dataFoto = [
  {
    id: 1,
    img: "https://plus.unsplash.com/premium_photo-1684106553975-0313ba8c2ee5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fGZvb3RiYWxsfGVufDB8fDB8fHww",
    desc: "Olahraga Sehat",
    date: "21-04-2023",
  },
  {
    id: 2,
    img: "https://bojonegorokab.go.id/storage/uploads/artikel/ARTIKEL20200830171412pm.jpg",
    desc: "Kerja Bakti",
    date: "02-09-2023",
  },
  {
    id: 3,
    img: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHNwb3J0fGVufDB8fDB8fHww",
    desc: "Sepeda Mingguan",
    date: "22-14-2023",
  },
  {
    id: 4,
    img: "https://balerejo.desa.id/asset/foto_berita/kerja-bakti.jpg",
    desc: "Jumaat Bersih",
    date: "01-01-2023",
  },
  {
    id: 5,
    img: "img-lomba.png",
    desc: "Senam Santai",
    date: "21-04-2023",
  },
  {
    id: 6,
    img: "img-lomba.png",
    desc: "Senam Santai",
    date: "21-04-2023",
  },
  {
    id: 7,
    img: "img-lomba.png",
    desc: "Senam Santai",
    date: "21-04-2023",
  },
];


export const dataProgram = [
  {
    title: "Jumaat Bersih",
    img: "https://plus.unsplash.com/premium_photo-1681483796585-e117184ac974?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description:
      "Pada dasarnya kebersihan adalah sebgaian dari iman, gotong royong menjadikan kekompakan bagi sesama, dan kepedulian terhadap lingkungan.",
    link: "/gallery",
  },
  {
    title: "Tadarus",
    img: "https://plus.unsplash.com/premium_photo-1676446443225-0aadc4ae2aa1?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description:
      "Dalam setiap minggunya , kami mengadakan tadarus di musholla tercinta kami, baik untuk anak-anak, ibu-ibu, maupun bapak-bapak.",
    link: "/gallery",
  },
  {
    title: "Dawis",
    img: "https://plus.unsplash.com/premium_photo-1675808577247-2281dc17147a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description:
      "Meningkatkan pengelolaan Gerakan PKK meliputi kegiatan pengorganisasian dan peningkatan Sumber Daya Manusia.",
    link: "/gallery",
  },
  {
    title: "Senam Sehat",
    img: "https://images.unsplash.com/photo-1526718583451-e88ebf774771?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description:
      "Senam sehat sarana untuk meningkatkan kesehatan mental, mengurangi stres, dan meningkatkan semangat hidup.",
    link: "/gallery",
  },
  {
    title: "Sejahtera",
    img: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description:
      "Program sejahtera memberikan bantuan finansial kepada warga yang mengalami musibah. Setiap bulan, iuran dikumpulkan untuk mendukung kelangsungan program ini.",
    link: "/gallery",
  },
];


// card anggota
export const cardAnggota = [
  {
    title: "Budi",
    jabatan: "Ketua",
    img: "budi-bg-blue.jpg",
  },
  {
    title: "Boy",
    jabatan: "Wakil",
    img: "budi-foto.jpg",
  },
  {
    title: "Prabowo",
    jabatan: "Menhan",
    img: "budi-foto.jpg",
  },
  {
    title: "Prabowo",
    jabatan: "Menhan",
    img: "budi-bg-blue.jpg",
  },
  {
    title: "Prabowo",
    jabatan: "Menhan",
    img: "budi-foto.jpg",
  },
];


const DataHelper = { dataFoto, dataProgram, cardAnggota };
export default DataHelper;